import {
    CHANGE_UPDATE_POLICY_FIELD, CHANGE_UPDATE_POLICY_FORM_DATA, FAILED_TO_RECEIVE_ALL_PREVIOUS_UPDATES,
    FAILED_TO_RECEIVE_UPDATE_QUESTIONS, GET_UPDATE_TAB_TAGS_DESCRIPTION, GET_UPDATE_TAB_TAGS_DESCRIPTION_FAIL,
    GET_UPDATE_TAB_TAGS_DESCRIPTION_SUCCESS, PREPOPULATE_UPDATE_FORM_FIELD,
    RECEIVE_BAD_REQUEST_POST_NO_CHANGES_UPDATE_POLICY_FORM,
    RECEIVE_BAD_REQUEST_POST_UPDATE_POLICY_FORM,
    RECEIVE_GET_ALL_PREVIOUS_UPDATES,
    RECEIVE_GET_UPDATE_QUESTIONS, RECEIVE_POST_NO_CHANGES_UPDATE_POLICY_FORM,
    RECEIVE_POST_UPDATE_POLICY_FORM, REQUEST_GET_ALL_PREVIOUS_UPDATES,
    REQUEST_GET_UPDATE_QUESTIONS, REQUEST_POST_NO_CHANGES_UPDATE_POLICY_FORM, REQUEST_POST_UPDATE_POLICY_FORM,
    UPDATE_POLICY_ATTACHMENTS_CHANGE,GET_COSTS_SUMMARY,
    RECEIVE_COSTS_SUMMARY,
    FAILED_TO_GET_COSTS_SUMMARY
} from "./index";

export function prePopulateUpdateFormField(payload) {
    return {
        type: PREPOPULATE_UPDATE_FORM_FIELD,
        payload: payload
    }
}

//action that requests the update tab tags description
export function getUpdateTabTagsDescription() {
    return {
        type: GET_UPDATE_TAB_TAGS_DESCRIPTION
    }
}

//action that receives the update tab tags description
export function getUpdateTabTagsDescriptionSuccess(payload) {
    return {
        type: GET_UPDATE_TAB_TAGS_DESCRIPTION_SUCCESS,
        payload: payload
    }
}

//action that receives error while fetching the update tab tags description
export function getUpdateTabTagsDescriptionFail(payload) {
    return {
        type: GET_UPDATE_TAB_TAGS_DESCRIPTION_FAIL,
        payload: payload
    }
}

export function requestGetUpdateQuestions(id) {
    return {
        type: REQUEST_GET_UPDATE_QUESTIONS,
        payload: id
    }
}

//action that receives GET questions
export function receiveGetUpdateQuestions(questions) {
    return {
        type: RECEIVE_GET_UPDATE_QUESTIONS,
        payload: questions
    }
}

//action that receives failed response from getting questions
export function failedToReceiveUpdateQuestions(response) {
    return {
        type: FAILED_TO_RECEIVE_UPDATE_QUESTIONS,
        payload: response
    }
}

//action that changes the redux fields
export function changeUpdatePolicyField(field, value) {
    return {
        type: CHANGE_UPDATE_POLICY_FIELD,
        payload: {
            key: field,
            value: value
        }
    }
}

export function changeUpdatePolicyFormData(field, value) {
    return {
        type: CHANGE_UPDATE_POLICY_FORM_DATA,
        payload: {
            key: field,
            value: value
        }
    }
}

export function requestPostUpdatePolicyForm(application) {
    return {
        type: REQUEST_POST_UPDATE_POLICY_FORM,
        payload: application
    }
}

export function receivePostUpdatePolicyFrom(response) {
    return {
        type: RECEIVE_POST_UPDATE_POLICY_FORM,
        payload: response
    }
}

export function receiveBadRequestPostUpdatePolicyForm(response) {
    return {
        type: RECEIVE_BAD_REQUEST_POST_UPDATE_POLICY_FORM,
        payload: response
    }
}

//action that changes the required field data stored in redux
export function updatePolicyAttachmentsChange(attachment) {
    return {
        type: UPDATE_POLICY_ATTACHMENTS_CHANGE,
        payload: attachment
    }
}

export function requestGetAllPreviousUpdates(applicationId) {
    return {
        type: REQUEST_GET_ALL_PREVIOUS_UPDATES,
        payload: applicationId
    }
}

export function receiveGetAllPreviousUpdates(response) {
    return {
        type: RECEIVE_GET_ALL_PREVIOUS_UPDATES,
        payload: response
    }
}

//action that receives failed response from getting All previous updates
export function failedToReceiveAllPreviousUpdates(response) {
    return {
        type: FAILED_TO_RECEIVE_ALL_PREVIOUS_UPDATES,
        payload: response
    }
}

export function requestPostNoChangesUpdatePolicyForm(application) {
    return {
        type: REQUEST_POST_NO_CHANGES_UPDATE_POLICY_FORM,
        payload: application
    }
}

export function receivePostNoChangesUpdatePolicyForm(response) {
    return {
        type: RECEIVE_POST_NO_CHANGES_UPDATE_POLICY_FORM,
        payload: response
    }
}

export function receiveBadRequestPostNoChangesUpdatePolicyForm(response) {
    return {
        type: RECEIVE_BAD_REQUEST_POST_NO_CHANGES_UPDATE_POLICY_FORM,
        payload: response
    }
}

export function getCostsSummary(payload) {
    return {
        type: GET_COSTS_SUMMARY,
        payload
    }
}

export function receiveCostsSummary(payload) {
    return {
        type: RECEIVE_COSTS_SUMMARY,
        payload
    }
}
export function failedToGetCostsSummary(payload) {
    return {
        type: FAILED_TO_GET_COSTS_SUMMARY,
        payload
    }
}